import script from "./DoughnutChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DoughnutChart.vue?vue&type=script&setup=true&lang=js"

import "./DoughnutChart.vue?vue&type=style&index=0&id=94d6bace&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94d6bace"]])

export default __exports__